export default __webpack_public_path__ + "static/media/new-orleans.28f0d931.jpeg";